import {
  useCreateFloorMutation,
  useDeleteFloorMutation,
  useGetAllFloorsQuery,
  useUpdateFloorMutation,
} from "../../../services/api/locationsApi";
import { useLocalSearchParams } from "expo-router";
import { FloorRequest } from "app/services/api/types/locations/requests/FloorRequest";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

export const useFloorManagement = () => {
  const { showErrorToast } = useDisplayToast();

  const [triggerCreateFloor] = useCreateFloorMutation();
  const [triggerUpdateFloor] = useUpdateFloorMutation();
  const [triggerDeleteFloor] = useDeleteFloorMutation();

  const locationId = Number(useLocalSearchParams().id);
  const { data: floors } = useGetAllFloorsQuery(
    {
      locationId,
    },
    { skip: !locationId },
  );

  const handleDeleteFloor = async (floorId: number) => {
    try {
      await triggerDeleteFloor({ floorId }).unwrap();
    } catch (e) {
      showErrorToast(e);
    }
  };

  const handleCreateFloor = async (data: FloorRequest) => {
    try {
      await triggerCreateFloor(data).unwrap();
    } catch (e) {
      showErrorToast(e);
    }
  };

  const handleUpdateFloor = async (floorId: number, data: FloorRequest) => {
    try {
      await triggerUpdateFloor({ floorId, body: data }).unwrap();
    } catch (e) {
      showErrorToast(e);
    }
  };

  return {
    floors,
    deleteFloor: handleDeleteFloor,
    updateFloor: handleUpdateFloor,
    createFloor: handleCreateFloor,
  };
};
